import React, { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import './style.scss';

function TextField({input, label, meta: { touched, error },}) {
  const editorRef = useRef(null);
  const log = () => {
    if (editorRef.current) {
      console.log(editorRef.current.getContent());
    }
  };
  return (
    <div>
      {label ? <label >{label}</label> : null}
      <Editor
        tinymceScriptSrc='/tinymce/tinymce.min.js'
         onInit={(evt, editor) => editorRef.current = editor}
         initialValue={input.value || '<p style="text-align: center; color: black; font-size: 18px;"><span style="font-size: 18px;"></span></p>'}
         onBlur={() => {
          if (editorRef.current) {
            input.onChange(editorRef.current.getContent())
            input.onBlur()
          }
         }}
         init={{
          height: 250,
          menubar: false,
          paste_as_text: true,
          plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount link image code media table',
          ],
          fontsize_formats: "8px 10px 12px 14px 18px 24px 36px",
          //  toolbar3: 'formatselect bold italic underline | bullist numlist outdent indent | code',
          toolbar2: '| alignright alignjustify alignselect aligncenter | bullist numlist outdent indent',
          toolbar1: 'fontsize | bold italic underline strikethrough superscript subscript codeformat | forecolor backcolor | image media | removeformat',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:18px }',
          images_upload_url: '/api/mcq1/upload-image',
          /* we override default upload handler to simulate successful upload*/
          // images_upload_handler: function (blobInfo, success, failure) {
          //   setTimeout(function () {
          //     /* no matter what you upload, we will turn it into TinyMCE logo :)*/
          //     success('http://moxiecode.cachefly.net/tinymce/v9/images/logo.png');
          //   }, 2000);
          // },
         }}
       />
        {touched && ((error && <span style={{color: 'red'}}>{error}</span>))}
    </div>
  )
}

export default React.memo(TextField)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/TextField/TextField.jsx